import React from "react";
import "tailwindcss/tailwind.css";
import "../../style/twform.css";
import { navigate } from "gatsby";

// silver icons
import mobileStepperSilver from "../../images/icons/stepper-silver-icon.svg";
import jaMobileStepperSilver from "../../images/icons/stepper-silver-icon-ja.svg";
import jaDesktopStepperSilver from "../../images/icons/desktop-silver-stepper-icon-ja.svg";
import zhMobileStepperSilver from "../../images/icons/silver-stepper-icon-zh.svg";
import zhDesktopStepperSilver from "../../images/icons/desktop-silver-stepper-icon-zh.svg";
import stepperSilver from "../../images/icons/desktop-stepper-silver-icon.svg";
import birthdayGiftSilver from "../../images/icons/birthday-icon-silver.svg";
import brandDiscountIconSilver from "../../images/icons/brand-discount-icon-silver.svg";
import roomDiscountIconSilver from "../../images/icons/room-discount-icon-silver.svg";
import welnessIconSilver from "../../images/icons/welness-icon-silver.svg";

// platinum icons
import jaMobileStepperPlatinum from "../../images/icons/stepper-platinum-icon-ja.svg";
import jaDesktopStepperPlatinum from "../../images/icons/desktop-platinum-stepper-icon-ja.svg";
import zhMobileStepperPlatinum from "../../images/icons/platinum-stepper-icon-zh.svg";
import zhDesktopStepperPlatinum from "../../images/icons/desktop-platinum-stepper-icon-zh.svg";
import mobileStepperPlatinum from "../../images/icons/stepper-platinum-icon.svg";
import stepperPlatinum from "../../images/icons/desktop-stepper-platinum-icon.svg";
import roomDiscountIconPlatinum from "../../images/icons/room-discount-icon-platinum.svg";
import complimentaryBreakfastIconPlatinum from "../../images/icons/comp-breakfast-icon-platinum.svg";
import roomUpgradeIconPlatinum from "../../images/icons/room-upgrade-icon-platinum.svg";
import bonusPointsIconPlatinum from "../../images/icons/bonus-points-icon-platinum.svg";
import earlyCheckInIconPlatinum from "../../images/icons/early-checkin-icon-platinum.svg";
import lateCheckOutIconPlatinum from "../../images/icons/late-checkout-icon-platinum.svg";
import welcomeGiftsIconPlatinum from "../../images/icons/welcome-gift-icon-platinum.svg";

// gold icons
import jaMobileStepperGold from "../../images/icons/stepper-gold-icon-ja.svg";
import jaDesktopStepperGold from "../../images/icons/desktop-gold-stepper-icon-ja.svg";
import zhMobileStepperGold from "../../images/icons/gold-stepper-icon-zh.svg";
import zhDesktopStepperGold from "../../images/icons/desktop-gold-stepper-icon-zh.svg";
import mobileStepperGold from "../../images/icons/stepper-gold-icon.svg";
import stepperGold from "../../images/icons/desktop-stepper-gold-icon.svg";
import roomDiscountIconGold from "../../images/icons/room-discount-icon-gold.svg";
import roomUpgradeIconGold from "../../images/icons/room-upgrade-icon-gold.svg";
import bonusPointsIconGold from "../../images/icons/bonus-points-icon-gold.svg";
import earlyCheckInIconGold from "../../images/icons/early-checkin-icon-gold.svg";
import lateCheckOutIconGold from "../../images/icons/late-checkout-icon-gold.svg";
import welcomeGiftsIconGold from "../../images/icons/welcome-gift-icon-gold.svg";

import Accordion from "./Accordion";

const MemberShipLevelDetail = ({
  membershipLevel,
  openWidgetAction,
  setIsDrawerOpen,
  locale,
  nightsToRetain,
  nightsNeededToNextLevel,
  levelPointsToRetain,
  experienceForNextLevel,
  levelValidity,
  levelPointsBalanceNumerator,
  levelPointsBalanceDenominator,
  nightsNumerator,
  nightsDenominator,
  langData,
  levelPointsProgressBar,
  levelPointsProgressBarMaxLevel,
  nightsProgressBar,
  nightsProgressBarMaxLevel,
}) => {
  const date = levelValidity ? new Date(`${levelValidity}`) : null;
  const options = { day: "numeric", month: "long", year: "numeric" };
  if (date && !isNaN(date.getTime())) {
    date.setDate(date.getDate() + 1);
  }
  const formattedDate = date && !isNaN(date.getTime())
    ? new Intl.DateTimeFormat("en-GB", options).format(date)
    : "";

  const handleExploreHotelsClick = () => {
    setIsDrawerOpen(false);
    openWidgetAction();
  };

  const renderMembershipMessage = (locale) => {
    const isPlatinum = membershipLevel === "Platinum";
    const points = isPlatinum
      ? levelPointsToRetain.toLocaleString()
      : experienceForNextLevel.toLocaleString();
    const nights = isPlatinum ? nightsToRetain : nightsNeededToNextLevel;

    const levelText =
      membershipLevel == "Silver"
        ? "Gold"
        : membershipLevel == "Gold"
        ? "Platinum"
        : "Platinum";

    switch (locale) {
      case "en":
        return membershipLevel == "Platinum" &&
          (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
            nightsProgressBar >= nightsProgressBarMaxLevel) ? (
          <>
            <span className="tw-font-normal">
              Level successfully maintained and it will be automatically
              extended on {""}
            </span>
            <span className="tw-font-semibold">
              {date.toLocaleDateString("en-GB", options)}
            </span>
          </>
        ) : (
          <>
            <span className="tw-font-normal">
              {isPlatinum ? "Maintain" : "Upgrade to"}{" "}
            </span>
            <span className="tw-font-semibold">{levelText}</span>
            <span className="tw-font-normal"> level by earning </span>
            <span className="tw-font-semibold">{points} more Level Points</span>
            <span className="tw-font-normal"> or </span>
            <span className="tw-font-semibold">{nights} more Nights</span>
            <span className="tw-font-normal"> before </span>
            <span className="tw-font-semibold">{levelValidity}</span>
          </>
        );
      case "ja":
        if (isPlatinum) {
          return membershipLevel == "Platinum" &&
            (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
              nightsProgressBar >= nightsProgressBarMaxLevel) ? (
            <>
              <span className="tw-font-normal">レベルは正常に維持され、</span>
              <span className="tw-font-semibold">
                {date.toLocaleDateString("en-GB", options)}
              </span>
              <span className="tw-font-normal">に自動的に延長されます。</span>
            </>
          ) : (
            <>
              <span className="tw-font-semibold">{levelValidity}</span>
              <span className="tw-font-normal">までに</span>
              <span className="tw-font-semibold">{points}</span>
              <span className="tw-font-normal">ポイントを獲得するか、</span>
              <span className="tw-font-semibold">{nights}</span>
              <span className="tw-font-normal">泊を追加することで</span>
              <span className="tw-font-semibold">{levelText}</span>
              <span className="tw-font-normal">レベルを維持できます</span>
            </>
          );
        } else {
          return (
            <>
              <span className="tw-font-semibold">{levelValidity}</span>
              <span className="tw-font-normal">までに</span>
              <span className="tw-font-semibold">{points}</span>
              <span className="tw-font-normal">ポイントを獲得するか、</span>
              <span className="tw-font-semibold">{nights}</span>
              <span className="tw-font-normal">泊を追加することで</span>
              <span className="tw-font-semibold">{levelText}</span>
              <span className="tw-font-normal">
                レベルにアップグレードできます
              </span>
            </>
          );
        }
      case "zh":
        if (isPlatinum) {
          return membershipLevel == "Platinum" &&
            (levelPointsProgressBar >= levelPointsProgressBarMaxLevel ||
              nightsProgressBar >= nightsProgressBarMaxLevel) ? (
            <>
              <span className="tw-font-normal">级别成功维护，并将在</span>
              <span className="tw-font-semibold">
                {date.toLocaleDateString("en-GB", options)}
              </span>
              <span className="tw-font-normal">自动延续。</span>
            </>
          ) : (
            <>
              <span className="tw-font-normal">在</span>
              <span className="tw-font-semibold">{levelValidity}</span>
              <span className="tw-font-normal">之前，通过获得额外的</span>
              <span className="tw-font-semibold">{points}</span>
              <span className="tw-font-normal">积分或增加</span>
              <span className="tw-font-semibold">{nights}</span>
              <span className="tw-font-normal">晚来维持</span>
              <span className="tw-font-semibold">{levelText}</span>
              <span className="tw-font-normal">级别</span>
            </>
          );
        } else {
          return (
            <>
              <span className="tw-font-normal">在</span>
              <span className="tw-font-semibold">{levelValidity}</span>
              <span className="tw-font-normal">之前，通过获得额外的</span>
              <span className="tw-font-semibold">{points}</span>
              <span className="tw-font-normal">积分或增加</span>
              <span className="tw-font-semibold">{nights}</span>
              <span className="tw-font-normal">晚来升级到</span>
              <span className="tw-font-semibold">{levelText}</span>
              <span className="tw-font-normal">级别</span>
            </>
          );
        }
      default:
        return "";
    }
  };

  const translations = {
    en: {
      earnMoreLevelPoints: {
        title: "Earn More Level Points",
        content: (
          <>
            Accumulate Level Points by transacting on eligible room rates,
            dining, spa treatments, and recreational facilities at participating
            brands.
            <br />
            <br />
            Earn <span className="tw-font-semibold">Level Points</span> through
            qualifying transactions, which help you advance or maintain your
            membership level. Bonus Points from promotions or membership status
            do not count towards level advancement.
          </>
        ),
        button: "Explore hotels to earn more points",
      },
      termsConditions: {
        title: "Terms & Conditions",
        content: (
          <ul className="tw-pl-5">
            <li>
              Insufficient points for upgrading or maintaining the level may
              result in a downgrade.
            </li>
            <li>
              Points earned before leveling up do not count toward maintaining a
              level.
            </li>
            <li>
              All eligible nights and level points will reset to zero at the end
              of the level's validity period.
            </li>
            <li>
              Using points for transactions or redemptions will not affect level
              progress.
            </li>
          </ul>
        ),
        button: "Read AYANA Rewards Terms & Conditions",
      },
    },
    ja: {
      earnMoreLevelPoints: {
        title: "レベルポイントを獲得する",
        content: (
          <>
            参加ブランドで対象の宿泊料金、ダイニング、スパトリートメント、およびレクリエーション施設を利用することで、レベルポイントを蓄積できます。
            <br />
            <br />
            購入対象の取引を通じてレベルポイントを獲得でき、会員レベルの昇格や維持に役立ちます。プロモーションや会員ステータスによるボーナスポイントは、レベル昇格にはカウントされません。
          </>
        ),
        button: "ホテルを探してポイントを獲得する",
      },
      termsConditions: {
        title: "利用規約",
        content: (
          <ul className="tw-pl-5">
            <li>
              アップグレードやレベルを維持するためのポイントが不足していると、ダウングレードされる可能性があります。
            </li>
            <li>
              レベルアップ前に獲得したポイントは、レベル維持にはカウントされません。
            </li>
            <li>
              対象となる宿泊日数とレベルポイントは、レベルの有効期限終了時にゼロにリセットされます。
            </li>
            <li>
              取引や引き換えにポイントを使用しても、レベル進行には影響しません。
            </li>
          </ul>
        ),
        button: "AYANA Rewards 利用規約を読む",
      },
    },
    zh: {
      earnMoreLevelPoints: {
        title: "赚取更多等级积分",
        content: (
          <>
            通过参与品牌的合格房价、餐饮、SPA护理及娱乐设施累积等级积分。
            <br />
            <br />
            通过符合条件的交易赚取等级积分，这可以帮助您提升或维持您的会员级别。促销或会员状态的奖励积分不能计入等级提升。
          </>
        ),
        button: "探索酒店以赚取更多积分",
      },
      termsConditions: {
        title: "条款与条件",
        content: (
          <ul className="tw-pl-5">
            <li>升级或维持等级所需的积分不足可能导致降级。</li>
            <li>在升级之前获得的积分不计入维持等级。</li>
            <li>所有合格的夜晚和等级积分将在等级有效期结束时重置为零。</li>
            <li>用于交易或兑换的积分不会影响等级进度。</li>
          </ul>
        ),
        button: "阅读 AYANA Rewards 条款与条件",
      },
    },
  };

  return (
    <>
      <div className="tw-text-[16px] md:tw-text-[20px] tw-leading-5 md:tw-leading-[28px] tw-text-[#464646] tw-font-opensans tw-font-semibold">
        {membershipLevel == "Platinum"
          ? `${langData.maintain_memebrship}`
          : `${langData.upgrade_membership}`}
      </div>
      {locale == "en" ? (
        <div className="tw-text-[14px] tw-leading-5 tw-font-normal tw-text-[#464646]">
          You are now a{" "}
          <span className="tw-font-semibold">{membershipLevel}</span> member
        </div>
      ) : locale == "ja" ? (
        <div className="tw-text-[14px] tw-leading-5 tw-font-normal tw-text-[#464646]">
          あなたは現在{" "}
          <span className="tw-font-semibold">{membershipLevel}</span> 会員です。
        </div>
      ) : locale == "zh" ? (
        <div className="tw-text-[14px] tw-leading-5 tw-font-normal tw-text-[#464646]">
          你现在是 <span className="tw-font-semibold">{membershipLevel}</span>{" "}
          会员。
        </div>
      ) : (
        ""
      )}
      <img
        className="tw-hidden md:tw-block"
        style={{ alignSelf: "center" }}
        src={
          membershipLevel === "Platinum"
            ? locale === "ja"
              ? jaDesktopStepperPlatinum
              : locale === "zh"
              ? zhDesktopStepperPlatinum
              : stepperPlatinum
            : membershipLevel === "Gold"
            ? locale === "ja"
              ? jaDesktopStepperGold
              : locale === "zh"
              ? zhDesktopStepperGold
              : stepperGold
            : locale === "ja"
            ? jaDesktopStepperSilver
            : locale === "zh"
            ? zhDesktopStepperSilver
            : stepperSilver
        }
        width={500}
        height={60}
      />
      <img
        className="md:tw-hidden tw-w-auto"
        style={{ alignSelf: "center" }}
        src={
          membershipLevel === "Platinum"
            ? locale === "ja"
              ? jaMobileStepperPlatinum
              : locale === "zh"
              ? zhMobileStepperPlatinum
              : mobileStepperPlatinum
            : membershipLevel === "Gold"
            ? locale === "ja"
              ? jaMobileStepperGold
              : locale === "zh"
              ? zhMobileStepperGold
              : mobileStepperGold
            : locale === "ja"
            ? jaMobileStepperSilver
            : locale === "zh"
            ? zhMobileStepperSilver
            : mobileStepperSilver
        }
      />
      <div
        className={`${
          membershipLevel == "Platinum"
            ? "tw-bg-[#333333CC]/[0.8]"
            : membershipLevel == "Gold"
            ? "tw-bg-[#D8BF8D40]/[0.25]"
            : "tw-bg-[#A5B0B326]/[0.15]"
        } tw-flex tw-flex-col tw-gap-2 tw-py-2 tw-px-3 tw-rounded-lg`}>
        <p
          className={`tw-p-0 tw-text-[14px] tw-leading-5 tw-font-normal tw-pb-2 tw-m-0 ${
            membershipLevel === "Platinum"
              ? "tw-text-[#FFFFFF]"
              : "tw-text-[#464646]"
          }`}
          style={{ borderBottom: "solid 1px #CACACA" }}>
          {renderMembershipMessage(locale)}
        </p>
        <div className="tw-flex tw-flex-col">
          <div
            className={`tw-flex tw-flex-row tw-justify-between tw-items-center ${
              membershipLevel === "Platinum"
                ? "tw-text-[#FFFFFF]"
                : "tw-text-[#464646]"
            }`}>
            <div>{langData.level_points}</div>
            <div>
              <span className="tw-font-semibold">
                {levelPointsBalanceNumerator.toLocaleString()}
              </span>{" "}
              / {levelPointsBalanceDenominator.toLocaleString()}
            </div>
          </div>
          <div
            className={`tw-flex tw-flex-row tw-justify-between tw-items-center ${
              membershipLevel === "Platinum"
                ? "tw-text-[#FFFFFF]"
                : "tw-text-[#464646]"
            }`}>
            <div>{langData.nights}</div>
            <div>
              <span className="tw-font-semibold">{nightsNumerator}</span> /{" "}
              {nightsDenominator}
            </div>
          </div>
        </div>
      </div>
      {/* Silver */}
      {membershipLevel == "Silver" && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
            {langData.your_benefits}
          </div>
          <div className="tw-grid-cols-2 tw-grid tw-grid-rows-2 tw-gap-3">
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={roomDiscountIconSilver} />
              <div>{langData.exclusive_room_discount}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={brandDiscountIconSilver} />
              <div>{langData.exclusive_discount_participating_brands}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={welnessIconSilver} />
              <div>{`${langData.wellness_benefits}`}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={birthdayGiftSilver} />
              <div>{langData.birthday_gift_during_stay}</div>
            </div>
          </div>
          <div className="tw-font-normal tw-text-[12px] tw-leading-5 tw-text-[#747474] tw-italic">
            {`*${langData.varies_by_property}`}
          </div>
        </div>
      )}
      {/* Gold */}
      {membershipLevel === "Gold" && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
            {langData.your_benefits}
          </div>
          <div className="tw-grid-cols-2 tw-grid tw-grid-rows-2 tw-gap-3">
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={roomDiscountIconGold} />
              <div>{langData.exclusive_room_discount}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={roomUpgradeIconGold} />
              <div>{langData.tier_room_upgrade}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={earlyCheckInIconGold} />
              <div>{langData.early_check_in}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={lateCheckOutIconGold} />
              <div>{langData.late_check_out_4pm}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={bonusPointsIconGold} />
              <div>{langData.bonus_points_25}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={welcomeGiftsIconGold} />
              <div>{langData.welcome_gifts}</div>
            </div>
          </div>
          <div className="tw-font-normal tw-text-[12px] tw-leading-5 tw-text-[#747474] tw-italic">
            {`*${langData.based_on_availability}`}
            <br />
            {`**${langData.varies_by_property}`}
          </div>
        </div>
      )}
      {/* Platinum */}
      {membershipLevel === "Platinum" && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
            {langData.your_benefits}
          </div>
          <div className="tw-grid-cols-2 tw-grid tw-grid-rows-2 tw-gap-3">
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={roomDiscountIconPlatinum} />
              <div>{langData.exclusive_room_discount}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img
                height={40}
                width={40}
                src={complimentaryBreakfastIconPlatinum}
              />
              <div>{langData.complimentary_one_time_breakfast}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={roomUpgradeIconPlatinum} />
              <div>{langData.tier_room_upgrade}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={bonusPointsIconPlatinum} />
              <div>{langData.bonus_points_50}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={earlyCheckInIconPlatinum} />
              <div>{langData.early_check_in}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={lateCheckOutIconPlatinum} />
              <div>{langData.late_check_out_6pm}</div>
            </div>
            <div className="tw-font-semibold tw-text-[12px] tw-leading-4 tw-text-[#464646] tw-gap-2 tw-flex tw-flex-row tw-justify-start tw-items-center">
              <img height={40} width={40} src={welcomeGiftsIconPlatinum} />
              <div>{langData.welcome_gifts}</div>
            </div>
          </div>
          <div className="tw-font-normal tw-text-[12px] tw-leading-5 tw-text-[#747474] tw-italic">
            {`*${langData.based_on_availability}`}
            <br />
            {`**${langData.varies_by_property}`}
          </div>
        </div>
      )}
      <button
        className="tw-p-0 tw-bg-transparent tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#37B0E5] tw-text-left tw-underline"
        onClick={() =>
          navigate(
            `${
              locale !== "en"
                ? `/${locale}/member-benefits`
                : "/member-benefits"
            }`
          )
        }>
        {langData.learn_more_about_member_benefit}
      </button>
      {membershipLevel === "Gold" && (
        <Accordion title={langData.maintaining_your_level}>
          <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
            {locale === "en" && (
              <>
                Maintain{" "}
                <span className="tw-font-semibold">{membershipLevel}</span>{" "}
                level by earning{" "}
                <span className="tw-font-semibold">
                  {levelPointsToRetain.toLocaleString()} Level Points
                </span>{" "}
                or{" "}
                <span className="tw-font-semibold">
                  {nightsToRetain} Nights
                </span>{" "}
                before{" "}
                <span className="tw-font-semibold">{levelValidity}.</span>
                <br></br>
                <br></br>
                <div>
                  If you successfully maintain your membership level before{" "}
                  <span className="tw-font-semibold">{levelValidity}</span>, it
                  will be automatically extended for the upcoming cycle.
                </div>
              </>
            )}
            {locale === "ja" && (
              <>
                {" "}
                {levelValidity}までに{" "}
                <span className="tw-font-semibold">
                  {levelPointsToRetain.toLocaleString()}ポイント
                </span>
                を獲得するか、{" "}
                <span className="tw-font-semibold">{nightsToRetain}泊</span>
                を追加することで{" "}
                <span className="tw-font-semibold">{membershipLevel}</span>
                レベルを維持できます <br></br>
                <br></br>
                <div>
                  <span className="tw-font-semibold">{levelValidity}</span>
                  前にメンバーシップレベルを維持できた場合、次の期間まで自動的に延長されます。
                </div>
              </>
            )}
            {locale === "zh" && (
              <>
                在 <span className="tw-font-semibold">{levelValidity}</span>
                之前，通过获得额外的{" "}
                <span className="tw-font-semibold">
                  {levelPointsToRetain.toLocaleString()}积分
                </span>{" "}
                或增加{" "}
                <span className="tw-font-semibold">{nightsToRetain}晚</span>{" "}
                来维持{" "}
                <span className="tw-font-semibold">{membershipLevel}</span>级别{" "}
                <br></br>
                <br></br>
                <div>
                  如果您在
                  <span className="tw-font-semibold">{levelValidity}</span>
                  之前成功保持您的会员级别，它将自动延长到下一个周期。
                </div>
              </>
            )}
          </div>
        </Accordion>
      )}
      <Accordion title={translations[locale].earnMoreLevelPoints.title}>
        <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
          {translations[locale].earnMoreLevelPoints.content}
          <br />
          <br />
          <button
            className="tw-p-0 tw-bg-transparent tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#37B0E5] tw-text-left tw-underline"
            onClick={handleExploreHotelsClick}>
            {translations[locale].earnMoreLevelPoints.button}
          </button>
        </div>
      </Accordion>
      <Accordion title={translations[locale].termsConditions.title}>
        <div className="tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#464646]">
          {translations[locale].termsConditions.content}
          <button
            className="tw-p-0 tw-bg-transparent tw-font-normal tw-text-[14px] tw-leading-5 tw-text-[#37B0E5] tw-text-left tw-underline"
            onClick={() =>
              navigate(
                `${
                  locale !== "en"
                    ? `/${locale}/terms-and-conditions-8#membership-levels`
                    : "/terms-and-conditions-8#membership-levels"
                }`
              )
            }>
            {translations[locale].termsConditions.button}
          </button>
        </div>
      </Accordion>
    </>
  );
};

export default MemberShipLevelDetail;
